import * as VueRouter from 'vue-router';
// @ts-ignore
import {useAuthStore} from "./Stores/Auth/AuthStore";
import DashboardView from "./Views/DashboardModule/DashboardView.vue";
import Sweetalert2 from "sweetalert2";
import {MovieTypeEnum} from "../Shared/Enums/MovieTypeEnum";

// Layout Pages
const LoginPage = () => import('./Layouts/Login/LoginPage.vue');
const RegisterPage = () => import('./Layouts/Register/RegisterPage.vue');
const AdminLayout = () => import('./Layouts/AdminLayout/AdminLayout.vue');

// Multi Module Frontend
const DynamicAdminModule = () => import('./Views/DynamicModule/DynamicAdminModule.vue');
const DocumentModule = () => import('./Views/DocumentModule/DocumentModule.vue');
const LogViewModule = () => import('./Views/LogViewModule/LogViewModule.vue');
const FormModule = () => import('./Views/FormModule/FormModule.vue');
const FormFillListModule = () => import('./Views/FormModule/FormFillsListModule.vue');
const PageModule = () => import('./Views/PageModule/PageModule.vue');
const LinkModule = () => import('./Views/LinkModule/LinkModule.vue');
const EmployeeDocumentModule = () => import('./Views/EmployeeDocument/EmployeeDocument.vue');
const LanguageModule = () => import('./Views/LanguageModule/LanguageModule.vue');
const NewsModule = () => import('./Views/NewsModule/NewsModule.vue')
const FaqModule = () => import('./Views/FaqModule/FaqModule.vue');

const SecondaryFooterModule = () => import('./Views/FooterModule/SecondaryFooterModule.vue');

//Configs
const ConfigViewModule = () => import('./Views/ConfigModule/ConfigModule.vue');
const ServiceModule = () => import('./Views/ConfigModule/ServiceModule.vue');
const CaptchaDriverModule = () => import('./Views/ConfigModule/CaptchaDriverModule.vue');

// Systems
const ColorPaletteModule = () => import('./Views/SystemModule/ColorPaletteModule.vue');
const LayoutModule = () => import('./Views/SystemModule/LayoutModule.vue');
const EmailModule = () => import('./Views/SystemModule/EmailModule.vue');
const CustomCSSModule = () => import('./Views/SystemModule/CustomCSSModule.vue');

const MediaLibraryModule = () => import('./Views/MediaLibrary/MediaLibraryModule.vue');
const ToolCategoryModule = () => import('./Views/ToolsModule/ToolCategoryModule.vue');

const routes = [
	// Logged in views
	{
		path: '/login',
		name: 'login',
		component: LoginPage,
	},
	///////////////////////////////////////////////
	// 	Register Vue
	///////////////////////////////////////////////
	{
		path: '/register',
		name: "register",
		component: RegisterPage,
	},
	{
		path: '/',
		component: AdminLayout,
		meta: {
			auth: true
		},
		children: [
			{
				path: '/dashboard',
				name: 'dashboard',
				component: DashboardView,
			},
			{
				path: '/documents',
				name: 'documents',
				alias: [
					'/documents/:id',
				],
				component: DocumentModule,
			},
			{
				path: '/system/layout',
				name: 'layout',
				component: LayoutModule,
			},
			{
				path: '/documents/group/:id',
				name: 'documents-group',
				component: DocumentModule,
			},
			{
				path: '/logs',
				name: 'logs',
				component: LogViewModule,
			},
			{
				path: '/config',
				name: 'config',
				component: ConfigViewModule,
			},
			{
				path: '/config/captcha',
				name: 'captcha',
				component: CaptchaDriverModule,
			},
			{
				path: '/config/services',
				name: 'services',
				component: ServiceModule,
			},
			{
				path: '/system/colors',
				name: 'colors',
				component: ColorPaletteModule,
			},
			{
				path: '/system/custom-css',
				name: 'custom-css',
				component: CustomCSSModule,
			},
			{
				path: '/pages',
				name: 'pages',
				component: PageModule,
			},
			{
				path: '/pages/:id',
				name: 'pages-show',
				component: PageModule,
			},
			{
				path: '/links',
				name: 'links',
				component: LinkModule,
			},
			{
				path: '/footer/secondary',
				name: 'footer-secondary',
				component: SecondaryFooterModule,
			},
			{
				path: '/footers',
				name: 'footers',
				alias: [
					'/footers/:id',
				],
				meta: {
					config: {
						name: 'Lábléc',
						sidebar: 'list',
						localize: true,
						breadcrumbs: [
							'Lábléc',
							'Listázás'
						],
						fields: [
							{
								type: 'input',
								title: 'Sorrend',
								name: 'order',
								slug: 'order',
								options: {
									type: 'number',
									min: 0,
									placeholder: 0,
								},
							},
							{
								type: 'input',
								title: 'Cím',
								name: 'title',
								slug: 'title',
							},
							{
								type: 'checkbox',
								title: 'Cím megjelenik?',
								name: 'show_title',
								slug: 'show_title',
								options: {
									text: 'Cím megjelenik'
								}
							},
							{
								type: 'tinymce',
								title: 'Tartalom',
								name: 'content',
								options: {},
							},
						],
						urls: {
							list: '/api/footers/list',
							store: '/api/footers',
							action: '/api/footers/',
						}
					}
				},
				component: DynamicAdminModule,
			},
			{
				path: '/languages',
				name: 'languages',
				alias: [
					'/languages/:id'
				],
				component: LanguageModule,
			},
			{
				path: '/translations',
				name: 'translations',
				alias: [
					'/translations/:id'
				],
				meta: {
					config: {
						name: 'Fordítások',
						sidebar: 'list',
						localize: true,
						breadcrumbs: [
							'Fordítások',
							'Listázás'
						],
						fields: [
							{
								type: 'input',
								title: 'Megnevezés',
								name: 'key',
								options: {
									readonly: true
								},
							},
							{
								type: 'input',
								title: 'Érték',
								name: 'value',
								options: {},
							},
						],
						urls: {
							list: '/api/translations/list',
							store: '/api/translations',
							action: '/api/translations/',
						}
					}
				},
				component: DynamicAdminModule,
			},
			{
				path: '/admins',
				name: 'admins',
				alias: [
					'/admins/:id'
				],
				meta: {
					config: {
						name: 'Adminisztrátorok',
						sidebar: 'list',
						localize: false,
						breadcrumbs: [
							'Adminisztrátorok',
							'Listázás'
						],
						fields: [
							{
								type: 'input',
								title: 'Teljes név',
								name: 'name',
							},
							{
								type: 'input',
								title: 'Email',
								name: 'email',
								options: {},
							},
							{
								type: 'input',
								title: 'Jelszó',
								name: 'password',
								options: {
									onlyEdit: true,
									type: 'password'
								}
							},
							{
								type: 'dropdown',
								title: 'Szerepkör',
								slug: 'role_id',
								name: 'role_id',
								default: 9999,
								options: {
									list: [
										{title: 'Kérjük válasszon!', value: '0'},
										{title: 'SuperAdmin', value: 9999},
										{title: 'Adminisztrátor', value: 5555},
									]
								}
							},
							{
								type: 'multi-checkbox-list',
								title: 'Jogosultságok',
								slug: 'permissions',
								name: 'permissions',
								showLeftList: false,
								options: {
									listUrl: '/api/permissions',
								}
							},
							{
								type: 'checkbox',
								title: 'Aktív',
								name: 'status',
								options: {
									onlyEdit: true,
								},
							},
						],
						urls: {
							list: '/api/admins/list',
							store: '/api/admins/invite',
							action: '/api/admins/',
						}
					}
				},
				component: DynamicAdminModule,
			},
			{
				path: '/news',
				name: 'news',
				alias: [
					'/news/:id'
				],
				meta: {
					config: {
						name: 'Hírek',
						sidebar: 'list',
						localize: true,
						breadcrumbs: [
							'Hírek',
							'Listázás'
						],
						fields: [
							{
								type: 'input',
								title: 'Cím',
								name: 'title',
							},
							{
								type: 'static-link',
								title: 'Bejegyzés link',
								name: 'slug',
								options: {
									//@ts-ignore
									prefix: `${import.meta.env.VITE_APP_URL}/news/`,
									onlyEdit: true,
								}
							},
							{
								type: 'textarea',
								title: 'Bevezető',
								name: 'introduction',
								options: {},
							},
							{
								type: 'media-library',
								title: 'Képfeltöltés',
								name: 'img_path',
								slug: 'img_path',
							},
							{
								type: 'tinymce',
								title: 'Tartalom',
								name: 'content',
								options: {},
							},
							{
								type: 'vue-select',
								title: 'Kategóriák',
								name: 'categories',
								slug: 'categories',
								options: {
									multiple: true,
									taggable: true,
									listUrl: '/api/news-categories',
								},
							},
							{
								type: 'vue-select',
								title: 'Címkék',
								name: 'tags',
								slug: 'tags',
								options: {
									multiple: true,
									taggable: true,
									listUrl: '/api/news-tags',
								},
							},
							{
								type: 'input',
								title: 'Dátum',
								name: 'created_at',
								options: {
									type: 'datetime-local'
								}
							},
							{
								type: 'checkbox',
								title: 'Státusz',
								name: 'status',
								options: {},
							},
							{
								type: 'block-input-unit',
								title: 'SEO',
								name: 'meta',
								options: {
									name: 'SEO bejegyzés',
									firstInputName: 'Kulcs',
									secondInputName: 'Megnevezés',
									firstInputKey: 'key',
									secondInputKey: 'value',
									firstInputPlaceholder: 'og:twitter',
									secondInputPlaceholder: 'https://google.com/kiscica.jpg',
								},
							},
						],
						urls: {
							list: '/api/news/list',
							store: '/api/news',
							action: '/api/news/',
						}
					}
				},
				component: NewsModule,
			},
			{
				path: '/news-categories',
				name: 'news-categories',
				alias: [
					'/news-categories/:id'
				],
				meta: {
					config: {
						name: 'Hír kategóriák',
						sidebar: 'list',
						localize: true,
						breadcrumbs: [
							'Hír kategóriák',
							'Listázás',
						],
						fields: [
							{
								type: 'input',
								title: 'Megnevezés',
								name: 'name',
								options: {},
							},
						],
						urls: {
							list: '/api/news-categories/list',
							store: '/api/news-categories',
							action: '/api/news-categories/',
						}
					}
				},
				component: DynamicAdminModule,
			},
			{
				path: '/news-tags',
				name: 'news-tags',
				alias: [
					'/news-tags/:id'
				],
				meta: {
					config: {
						name: 'Hír cimkék',
						sidebar: 'list',
						localize: true,
						breadcrumbs: [
							'Hír cimkék',
							'Listázás',
						],
						fields: [
							{
								type: 'input',
								title: 'Megnevezés',
								name: 'name',
								options: {},
							},
						],
						urls: {
							list: '/api/news-tags/list',
							store: '/api/news-tags',
							action: '/api/news-tags/',
						}
					}
				},
				component: DynamicAdminModule,
			},
			{
				path: '/blogs',
				name: 'blogs',
				alias: [
					'/blogs/:id'
				],
				meta: {
					config: {
						name: 'Blogok',
						sidebar: 'list',
						localize: true,
						breadcrumbs: [
							'Blogok',
							'Listázás'
						],
						fields: [
							{
								type: 'input',
								title: 'Cím',
								name: 'title',
							},
							{
								type: 'static-link',
								title: 'Bejegyzés link',
								name: 'slug',
								options: {
									//@ts-ignore
									prefix: `${import.meta.env.VITE_APP_URL}/blogs/`,
									onlyEdit: true,
								}
							},
							{
								type: 'textarea',
								title: 'Bevezető',
								name: 'introduction',
								options: {},
							},
							{
								type: 'media-library',
								title: 'Képfeltöltés',
								name: 'img_path',
								slug: 'img_path',
							},
							{
								type: 'tinymce',
								title: 'Tartalom',
								name: 'content',
								options: {},
							},
							{
								type: 'vue-select',
								title: 'Címkék',
								name: 'tags',
								slug: 'tags',
								options: {
									multiple: true,
									taggable: true,
								},
							},
							{
								type: 'input',
								title: 'Dátum',
								name: 'created_at',
								options: {
									type: 'datetime-local'
								}
							},
						],
						urls: {
							list: '/api/blogs/list',
							store: '/api/blogs',
							action: '/api/blogs/',
						}
					}
				},
				component: DynamicAdminModule,
			},
			{
				path: '/media/:id?',
				name: 'media',
				component: MediaLibraryModule,
			},
			{
				path: '/tool-categories',
				name: 'tool-categories',
				component: ToolCategoryModule,
			},
			{
				path: '/tool-categories/:id',
				name: 'tool-category-show',
				component: ToolCategoryModule,
			},
			{
				path: '/tools',
				name: 'tools',
				alias: [
					'/tools/:id'
				],
				meta: {
					config: {
						name: 'Eszközök',
						sidebar: 'list',
						localize: true,
						breadcrumbs: [
							'Eszközök',
							'Listázás'
						],
						fields: [
							{
								type: 'input',
								title: 'Megnevezés',
								name: 'title',
							},
							{
								type: 'vue-select',
								title: 'Eszköz kategória',
								name: 'category_id',
								slug: 'category_id',
								options: {
									listUrl: '/api/tool-categories',
								},
							},
							{
								type: 'media-library',
								title: 'Képfeltöltés',
								name: 'img_path',
								slug: 'img_path',
							},
							{
								type: 'tinymce',
								title: 'Leírás',
								name: 'description',
								options: {},
							},
						],
						urls: {
							list: '/api/tools/list',
							store: '/api/tools',
							action: '/api/tools/',
						}
					}
				},
				component: DynamicAdminModule,
			},
			{
				path: '/movies',
				name: 'movies',
				alias: [
					'/movies/:id'
				],
				meta: {
					config: {
						name: 'Filmek',
						sidebar: 'list',
						localize: true,
						breadcrumbs: [
							'Filmek',
							'Listázás'
						],
						fields: [
							{
								type: 'input',
								title: 'Cím',
								name: 'title',
							},
							{
								type: 'input',
								title: 'Alcím',
								name: 'subtitle',
							},
							{
								type: 'input',
								title: 'Link',
								name: 'url',
							},
							{
								type: 'input',
								title: 'Bemutató dátum',
								name: 'released_date',
								options: {
									type: 'datetime-local'
								}
							},
							{
								type: 'dropdown',
								title: 'Statusz',
								slug: 'status',
								name: 'status',
								default: 0,
								options: {
									list: [
										{title: 'Kérjük válasszon!', value: '-1'},
										{title: 'Hamarosan a mozikban', value: MovieTypeEnum.COMING_SOON_TO_THEATERS},
										{title: 'Már a mozikban', value: MovieTypeEnum.NOW_IN_THEATERS},
										{title: 'Korábbi filmjeink', value: MovieTypeEnum.OUR_PREVIOUS_FILMS},
									]
								}
							},
							{
								type: 'media-library',
								title: 'Állókép',
								name: 'portrait_image',
								slug: 'portrait_image',
							},
							{
								type: 'media-library',
								title: 'Fekvőkép',
								name: 'landscape_image',
								slug: 'landscape_image',
							},
						],
						urls: {
							list: '/api/movies/list',
							store: '/api/movies',
							action: '/api/movies/',
						}
					}
				},
				component: DynamicAdminModule,
			},
		]
	},
	{path: '/:pathMatch(.*)*', name: '404', redirect: '/'},
]

const router = VueRouter.createRouter({
	history: VueRouter.createWebHistory(),
	routes,
});

router.beforeEach(async (to, from, next) => {
	const store = useAuthStore();

	if ((to.name !== 'login' && to.name !== 'register') && !store.isLoggedIn) {
		next({name: "login"});
	} else if ((to.name === 'login' || to.name === 'register') && store.isLoggedIn) {
		next({name: 'dashboard'});
	} else if (store.isLoggedIn === false && to.meta.auth === true) {
		await Sweetalert2.fire({
			title: 'Kérlek jelentkezz be az oldal megtekintéséhez!',
			icon: 'warning',
			confirmButtonColor: 'var(--colorMain)',
			confirmButtonText: 'OK'
		});
		await router.push({name: 'home'});
		return;
	}
	// Otherwise allowed viewing..
	if (store.isLoggedIn && !store.isLoaded) {
		await store.getMe();
	}
	next();
});

export default router;
